import { useEffect } from 'react';

/**
 * 粘贴上传 Hook
 * @param doUpload 粘贴到文件时触发的上传函数
 */
export function usePasteUpload(doUpload: (file: File) => void): void {
  useEffect(() => {
    function handlePaste(event: ClipboardEvent): void {
      if (event.clipboardData == null) return;
      const items = Array.from(event.clipboardData.items);
      for (const item of items) {
        if (item.kind === 'file') {
          const file = item.getAsFile();
          if (file == null) continue;
          doUpload(file);
        }
      }
    }
    window.addEventListener('paste', handlePaste);
    return (): void => {
      window.removeEventListener('paste', handlePaste);
    };
  }, [doUpload]);
}
